export default {
  namespaced: true,
  stream_type: {
    title: "Tipo de stream",
    master_account_title: "Tipo de stream padrão",
    select_placeholder: "Selecione os tipos de stream",
    inherited_from_master_account: "Serão usados os da conta mestra",
    none_configured: "Sem tipos configurados, todos os streams disponíveis serão retornados",
    order_help: "A ordem da lista é a ordem em que os streams são retornados.",
  },
};
